import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { SearchResult } from '../search-result';

const commonStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
	backgroundColor: 'color.background.accent.gray.subtlest',
	borderRadius: 'radius.small',
});

const skeletonTextStyles = xcss({
	height: '14px',
	marginTop: 'space.025',
	marginBottom: 'space.025',
});

const titleStyles = xcss({
	width: '280px',
});

const iconStyles = xcss({
	width: 'size.200',
	height: 'size.200',
});

const containerStyles = xcss({
	pointerEvents: 'none',
});

const descriptionContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
});

const descriptionStyles = xcss({
	width: '100%',
});

const metadataStyles = xcss({
	width: '200px',
});

const subMetaDataStyles = xcss({
	width: '50px',
});

export const MetaDataItemSkeleton = (): React.JSX.Element => {
	return <Box xcss={[commonStyles, skeletonTextStyles, subMetaDataStyles]} />;
};

const metaDataWideStyles = xcss({
	width: '100px',
});

export const MetaDataItemSkeletonWide = (): React.JSX.Element => {
	return <Box xcss={[commonStyles, skeletonTextStyles, metaDataWideStyles]} />;
};

export const SearchResultSkeleton = (): React.JSX.Element => {
	return (
		<Box xcss={containerStyles} role="list">
			<SearchResult
				description={
					<Box xcss={[descriptionContainerStyles]}>
						<Box xcss={[commonStyles, skeletonTextStyles, descriptionStyles]} />
						<Box xcss={[commonStyles, skeletonTextStyles, descriptionStyles]} />
					</Box>
				}
				icon={<Box xcss={[commonStyles, iconStyles]} />}
				title={<Box xcss={[commonStyles, skeletonTextStyles, titleStyles]} />}
				headerMetadata={<Box xcss={[commonStyles, skeletonTextStyles, metadataStyles]} />}
			/>
		</Box>
	);
};
